import { StatisticsModel } from '../../models';

export interface IState {
  wfmExpanded: {
    workers: StatisticsModel.IExpandedWorkersOnsiteResponse;
    companies: StatisticsModel.IExpandedCompaniesOnsiteResponse;
    workersForCompany: StatisticsModel.IExpandedWorkersOnsiteResponse;
    trades: StatisticsModel.IExpandedTradesOnsiteResponse;
    workersForTrade: StatisticsModel.IExpandedWorkersOnsiteResponse;
  };
  dailyLogExpanded: {
    newWorkersBadged: StatisticsModel.IExpandedWorkersOnsiteResponse;
    newCompaniesEnrolled: StatisticsModel.IExpandedCompaniesOnsiteResponse;
    workersForNewCompany: StatisticsModel.IExpandedWorkersOnsiteResponse;
    trades: StatisticsModel.IExpandedTradesOnsiteResponse;
    workersForTrade: StatisticsModel.IExpandedWorkersOnsiteResponse;
    totalHeadcount: StatisticsModel.IExpandedWorkersOnsiteResponse;
    totalCompanies: StatisticsModel.IExpandedCompaniesOnsiteResponse;
    workersForTotalCompany: StatisticsModel.IExpandedWorkersOnsiteResponse;
    totalOnsiteHours: StatisticsModel.IExpandedWorkersOnsiteResponse;
  };
  inProgressExports: any;
}

export const initialState: IState = {
  wfmExpanded: {
    workers: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    companies: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    workersForCompany: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    trades: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    workersForTrade: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
  },
  dailyLogExpanded: {
    newWorkersBadged: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    newCompaniesEnrolled: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    workersForNewCompany: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    trades: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    workersForTrade: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    totalHeadcount: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    totalCompanies: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    workersForTotalCompany: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
    totalOnsiteHours: {
      pageNumber: 1,
      pageSize: 15,
      totalResults: 0,
      items: [],
    },
  },
  inProgressExports: {},
};
